// extracted by mini-css-extract-plugin
export default {"st3":"BlockCreatorIcon_st3__yZ4dG"};